import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'context/AuthContext';
import { ROUTES } from 'config/routes';

interface QuickOrderHeaderButtonProps {
  contrast?: boolean;
}

const QuickOrderHeaderButton: React.FC<QuickOrderHeaderButtonProps> = ({ contrast }) => {
  const { t } = useTranslation('common');
  const { isAuthenticated } = useAuthContext();
  if (!isAuthenticated) return null;

  const label = t('nav.quickOrder');

  return (
    <Tooltip title={label}>
      <IconButton
        component={RouterLink}
        to={ROUTES.QUICK_ORDER}
        color={contrast ? 'inherit' : 'default'}
        aria-label={label}
      >
        <PlaylistAddOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};

export default QuickOrderHeaderButton;
